<template>
  <div class="keyboard-box">
    <div v-for="(itemRow, index) in keyboard" :key="index" class="keyboard-row">
      <div v-for="(itemCell, index2) in itemRow" :key="index2" class="keyboard-cell" @click="inputValue += itemCell">
        {{ itemCell }}
      </div>
    </div>

    <div class="keyboard-row">
      <div class="keyboard-cell span2" @click="inputValue += 0">0</div>
      <div class="keyboard-cell" @click="inputValue = inputValue.slice(0, inputValue.length - 1)">
        <img src="@/assets/backDel.svg" class="icon"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumKeyboard",
  data() {
    return {
      keyboard: [
        [1, 2, 3],
        [4, 5, 6],
        [7, 8, 9],
      ],
      inputValue: "",
    }
  },
  watch: {
    inputValue(newVal) {
      this.$emit("inputCallback", newVal)
    }
  }
}
</script>


<style scoped lang="less">
// theme-a 数字键盘（11-code-enter 设计稿）
.keyboard-box {
  width: 640px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  background: #eceeec;
  padding: 20px;
  border-radius: 24px;
  box-sizing: border-box;

  .keyboard-row {
    display: contents;
  }

  .keyboard-cell {
    height: 150px;
    border-radius: 18px;
    background: #fff;
    font-size: 52px;
    font-weight: 500;
    color: var(--ink);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(20, 30, 25, 0.05);
    user-select: none;

    &:active {
      background: #eef1ee;
    }

    &.span2 {
      grid-column: span 2;
    }

    .icon {
      width: 56px;
      height: 40px;
    }
  }
}
</style>
